import aesjs from 'aes-js';

const MAX_SIZE = 8192 * 2; // 50kb is max size of encryption
const NUM_PARTITIONS = 256;

const algo = {
    name: "AES-CTR",
    //Don't re-use counters!
    //Always use a new counter every time your encrypt!
    counter: new aesjs.Counter(5)._counter,
    length: 64, //can be 1-128
};

// content key must be in buffer
export async function miniEncrypt(contentBytes, contentKey) {
    if (contentBytes.length < MAX_SIZE) {
        // just encrypt
        return await encrypt(contentBytes, contentKey);
    }
    let contentToEncrypt = getContentToEncrypt(contentBytes);

    let miniEncryptedContent = await encrypt(contentToEncrypt, contentKey);
    let interleavedContent = interleaveContent(contentBytes, new Uint8Array(miniEncryptedContent));
    return interleavedContent;
}

function interleaveContent(contentBytes, miniEncryptedContent) {
    let partitionBytes = Math.ceil(MAX_SIZE / NUM_PARTITIONS);
    let partitionSize = Math.floor(contentBytes.length / NUM_PARTITIONS);
    for (let i=0; i < NUM_PARTITIONS; i++ ){
        // get partitionBytes many bytes from this partition
        let position = i * partitionSize;
        let miniPosition = i * partitionBytes;
        contentBytes.set(miniEncryptedContent.subarray(miniPosition, miniPosition + partitionBytes), position);
    }

    return contentBytes;
}

function getContentToEncrypt(contentBytes) {
    // otherwise we need to mini encrypt
    let partitionBytes = Math.ceil(MAX_SIZE / NUM_PARTITIONS);
    let partitionSize = Math.floor(contentBytes.length / NUM_PARTITIONS);
    let contentToEncrypt = new Uint8Array(MAX_SIZE);
    for (let i=0; i < NUM_PARTITIONS; i++ ){
        // get partitionBytes many bytes from this partition
        let position = i * partitionSize;
        contentToEncrypt.set(contentBytes.subarray(position, position + partitionBytes), i * partitionBytes);
    }
    return contentToEncrypt;
}

export async function encrypt(contentBytes, contentKey) {
    let importedKey = await window.crypto.subtle.importKey(
        'raw',
        new Uint8Array(contentKey).buffer,
        {name: 'AES-CTR'},
        false,
        ['encrypt', 'decrypt'],
    );

    return await window.crypto.subtle.encrypt(algo, importedKey, new Uint8Array(contentBytes));
}

export async function miniDecrypt(contentBytes, contentKey) {
    if (contentBytes.length < MAX_SIZE) {
        let x = await decrypt(contentBytes, contentKey);
        return new Uint8Array(x);
    }

    let contentToDecrypt = getContentToEncrypt(contentBytes);
    let miniDecryptedContent = new Uint8Array(await decrypt(contentToDecrypt, contentKey));
    let inter = interleaveContent(contentBytes, miniDecryptedContent);
    return inter;
}

export async function decrypt(contentBytes, contentKey) {
    let importedKey = await window.crypto.subtle.importKey(
        'raw',
        new Uint8Array(contentKey).buffer,
        {name: 'AES-CTR'},
        false,
        ['decrypt'],
    );
    return await window.crypto.subtle.decrypt(algo, importedKey, contentBytes);
}
